module.exports = __webpack_public_path__ + "img/media-kit.3efcc2d1.png";